
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

const HeroSection = () => {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const heroImages = [
    {
      url: "https://public.readdy.ai/ai/img_res/7701e1dadd7831bcd0c51c5359562879.jpg",
      title: "Protégez Votre",
      subtitle: "Entreprise",
      description: "Solutions de sécurité complètes et sur mesure pour votre entreprise. Vidéo surveillance, détection incendie, contrôle d'accès et plus encore."
    },
    {
      url: "https://readdy.ai/api/search-image?query=Professional%20security%20surveillance%20cameras%20installation%20on%20modern%20building%20exterior%2C%20high-tech%20CCTV%20system%20with%20infrared%20night%20vision%2C%20sleek%20white%20and%20black%20security%20cameras%2C%20corporate%20building%20facade%2C%20professional%20security%20installation%2C%20modern%20architecture%20with%20security%20technology%2C%20clean%20minimalist%20design&width=1920&height=1080&seq=hero-cobra-security-2&orientation=landscape",
      title: "Surveillance",
      subtitle: "24h/24",
      description: "Systèmes de vidéosurveillance haute définition avec monitoring en temps réel. Protection continue de vos locaux et de vos biens."
    },
    {
      url: "https://readdy.ai/api/search-image?query=Modern%20access%20control%20system%20with%20biometric%20fingerprint%20scanner%20and%20keycard%20reader%20on%20glass%20door%2C%20sleek%20corporate%20office%20entrance%2C%20professional%20security%20technology%2C%20clean%20modern%20design%20with%20blue%20LED%20lighting%2C%20high-tech%20access%20control%20panel%2C%20secure%20building%20entrance&width=1920&height=1080&seq=hero-cobra-security-3&orientation=landscape",
      title: "Contrôle",
      subtitle: "d'Accès",
      description: "Systèmes de contrôle d'accès biométriques et par badges. Gérez les entrées et sorties de votre entreprise en toute sécurité."
    },
    {
      url: "https://readdy.ai/api/search-image?query=Advanced%20fire%20detection%20and%20alarm%20system%20in%20modern%20office%20building%2C%20smoke%20detectors%20and%20fire%20alarm%20panels%20on%20white%20ceiling%2C%20professional%20fire%20safety%20equipment%2C%20clean%20corporate%20interior%20with%20red%20emergency%20lighting%2C%20modern%20fire%20protection%20technology%2C%20safety%20systems&width=1920&height=1080&seq=hero-cobra-security-4&orientation=landscape",
      title: "Détection",
      subtitle: "Incendie",
      description: "Systèmes de détection incendie intelligents et conformes aux normes. Protection optimale contre les risques d'incendie."
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change d'image toutes les 5 secondes

    return () => clearInterval(interval);
  }, [heroImages.length]);

  const handleDevisClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleServicesClick = () => {
    navigate('/services');
  };

  const currentImage = heroImages[currentImageIndex];

  return (
    <section 
      id="accueil" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat transition-all duration-1000 ease-in-out"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("${currentImage.url}")`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight transition-all duration-500">
            {currentImage.title}
            <span className="text-red-500 block">{currentImage.subtitle}</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed transition-all duration-500">
            {currentImage.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="primary" 
              size="lg"
              className="bg-red-600 text-white hover:bg-red-700 px-8 py-4 text-lg"
              onClick={handleDevisClick}
            >
              <i className="ri-phone-line mr-2"></i>
              Devis Gratuit
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 text-lg"
              onClick={handleServicesClick}
            >
              <i className="ri-play-circle-line mr-2"></i>
              Nos Services
            </Button>
          </div>
        </div>
      </div>

      {/* Indicateurs de slides */}
      <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex space-x-3">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentImageIndex 
                ? 'bg-red-500 scale-125' 
                : 'bg-white/50 hover:bg-white/75'
            }`}
          />
        ))}
      </div>

      {/* Flèche de défilement */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
